import { ConfirmOtpPage } from '@/features/account/ConfirmOtpPage'

/**
 * The forgot-password branch: confirming the code unlocks /Account/ResetPassword.
 * Views/Account/ConfirmEmail.cshtml + wwwroot/js/app/account/confirmEmail.js.
 */
export function ConfirmEmail(): JSX.Element {
  return (
    <ConfirmOtpPage
      title="Confirm Email"
      resendLabel="Resend Code"
      purpose="reset"
      fallbackRedirect="/Account/ResetPassword"
      restartRedirect="/Account/ForgotPassword"
      restartMessage="Email not found. Please start the password reset process again."
    />
  )
}
